<template>
  <div>
    <section class="how-it-works">
      <div class="how-it-works__header">
        <h1>{{ getTranslations.components_how_it_works }}</h1>
      </div>
      <div class="how-it-works__content">
        <div class="how-it-works__item how-it-works__item--green">
          <div class="how-it-works__item__content">
            <div class="how-it-works__item__text">
              <h2>{{ getTranslations.how_it_works_get_started }}</h2>
              <p>{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_hiwc_get_started1') }}</p>
              <p>{{ getTranslations.project_hiwc_get_started2 }}</p>
              <p>{{ getTranslations.project_hiwc_get_started3 }}</p>
            </div>
            <div class="how-it-works__item__image">
              <img src="static/images/get_started.png" :alt="getTranslations.project_config_index_duel_get_started">
            </div>
          </div>
        </div>
        <div class="how-it-works__item how-it-works__item--blue">
          <div class="how-it-works__item__content">
            <div class="how-it-works__item__image">
              <img src="static/images/play_against_others.png" :alt="getTranslations.project_config_index_play_against_others">
            </div>
            <div class="how-it-works__item__text">
              <h2>{{ getTranslations.how_it_works_play_against_others }}</h2>
              <p>{{ getTranslations.project_hiwc_play_against_others1 }}</p>
              <p>{{ getTranslations.project_hiwc_play_against_others2 }}</p>
              <p>{{ getTranslations.project_hiwc_play_against_others3 }}</p>
              <p>{{ getTranslations.project_hiwc_play_against_others4 }}</p>
            </div>
          </div>
        </div>
        <div class="how-it-works__item how-it-works__item--green">
          <div class="how-it-works__item__content">
            <div class="how-it-works__item__text">
              <h2>{{ getTranslations.how_it_works_earn_points_status }}</h2>
              <p>{{ getTranslations.project_hiwc_earn_points_status1 }}</p>
              <p>{{ getTranslations.project_hiwc_earn_points_status2 }}</p>
            </div>
            <div class="how-it-works__item__image">
              <img src="static/images/earn_points.png" alt="">
            </div>
          </div>
        </div>
        <div class="how-it-works__item how-it-works__item--blue">
          <div class="how-it-works__item__content">
            <div class="how-it-works__item__image">
              <img src="static/images/win_prizes.png" alt="">
            </div>
            <div class="how-it-works__item__text">
              <h2>{{ getTranslations.how_it_works_win_prizes }}</h2>
              <p>{{ getTranslations.project_hiwc_win_prizes1 }}</p>
              <p>{{ getTranslations.project_hiwc_win_prizes2 }}</p>
              <p>{{ getTranslations.project_hiwc_win_prizes3 }}</p>
            </div>
          </div>
        </div>
        <div class="faq">
          <div class="faq__header">
            <h3>{{ getTranslations.components_how_it_works_frequently_asked_questions }}</h3>
          </div>
          <div class="faq__container">
            <ul class="accordion">
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_1 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_1_row_1 }}<a :href="'mailto:'+getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_faq_answer_1_email')">{{ getTranslations.project_faq_answer_1_email }}</a>{{ getTranslations.project_faq_answer_1_row_2 }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_2 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_2 }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_3 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_3 }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_4 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_4 }}<br><br>
                  <ul>
                    <li>{{ getTranslations.project_faq_answer_4_bullet_1 }}</li>
                    <li>{{ getTranslations.project_faq_answer_4_bullet_2 }}</li>
                    <li>{{ getTranslations.project_faq_answer_4_bullet_3 }}</li>
                  </ul>
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_5 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_5 }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_6 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_6 }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_7 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_7_row1 }}<br><br>
                  {{ getTranslations.project_faq_answer_7_row2 }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_8 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_8 }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_9 }}</a>
                <div class="inner">
                  {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_faq_answer_9') }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_10 }}</a>
                <div class="inner">
                  {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_faq_answer_10') }}
                </div>
              </li>
              <li>
                <a class="toggle-accordion" href="javascript:void(0);">{{ getTranslations.faq_question_11 }}</a>
                <div class="inner">
                  {{ getTranslations.project_faq_answer_11 }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <button class="goto-top" @click.prevent="checkTopButton" style="display: none">
      <img :src="imageTop" @error="imageErrorHandler" alt="">
    </button>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'howItWorks',
  data() {
    return {
      imageTop: '/ext/skin/top_icon.png',
    };
  },
  mounted() {
    /* eslint-disable */
    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(scroll > 500) {
        $('.goto-top').fadeIn();
      }
      else {
        $('.goto-top').fadeOut();
      }
    });
    /* eslint-enable */
    this.$nextTick(() => {
      /* eslint-disable */
      // initAccordion
      $('.toggle-accordion').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        $('.toggle-accordion').removeClass('show');

        if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.removeClass('show');
          $this.next().slideUp(350);
        } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.addClass('show');
          $this.next().slideToggle(350);
        }
      });
      /* eslint-enable */
    });
  },
  methods: {
    imageErrorHandler() {
      this.imageTop = 'static/images/top_icon.png';
    },
    checkTopButton() {
      /* eslint-disable */
      $(window).scrollTop(0);
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'duelSkin',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HowItWorks.vue